import { Navigate, useParams } from 'react-router-dom';

import { useNamespace } from '@splitfiesta/i18n';

import { GroupPageLayout } from '@/components/groups/GroupPageLayout';
import { PaymentSuggestions } from '@/components/groups/PaymentSuggestions';
import { MembersSection } from '@/components/groups/sections/MembersSection';

import { useGroupWithDashboardQuery } from '@/hooks/queries/useGroups';

import { useAuthStore } from '@/stores/authStore';

export default function GroupBalancesPage() {
  const { id: groupId } = useParams<{ id: string }>();
  const user = useAuthStore(state => state.user);

  // Load required namespaces - must be before any conditional returns
  const groupsLoaded = useNamespace('groups');
  const balancesLoaded = useNamespace('balances');
  const membersLoaded = useNamespace('members');
  const commonLoaded = useNamespace('common');

  const allNamespacesLoaded =
    groupsLoaded && balancesLoaded && membersLoaded && commonLoaded;

  // Get group data - this will be cached from GroupPageLayout
  const { data: group } = useGroupWithDashboardQuery(
    groupId ?? '',
    allNamespacesLoaded && !!user && !!groupId
  );

  // Early return after all hooks have been called
  if (!groupId) {
    return <Navigate to="/groups" replace />;
  }

  if (!allNamespacesLoaded) {
    return null; // GroupPageLayout will show skeleton
  }

  return (
    <GroupPageLayout groupId={groupId}>
      <div data-testid="group-balances-container" className="space-y-6">
        {group && <MembersSection group={group} currentUserId={user?.id} />}
        {group && <PaymentSuggestions group={group} />}
      </div>
    </GroupPageLayout>
  );
}
